export default __webpack_public_path__ + "static/media/ArtiboniteImg.a07ea19a.jpg";